<template>
  <div>
    <a-row class="filter mb-3" type="flex">
      <a-col :xs="24" :md="12" :lg="6" class="order-2">
        <a-input-search
          placeholder="Search by keyword"
          :value="$route.query.q"
          @change="onQueryChanged"
        />
      </a-col>
      <a-col :xs="24" :md="12" :lg="6" class="ml-auto text-md-right order-1 order-md-2">
        <router-link :to="{ name: 'catalogue.product.create' }">
          <a-button type="primary" icon="plus" class="mb-3 mb-md-0">Add New Product</a-button>
        </router-link>
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="products"
      :loading="loading"
      :row-key="(item) => item.product_id"
      :pagination="false"
      class="table-products"
      bordered
      :scroll="{ y: 450 }"
    >
      <div slot="name" slot-scope="record" class="d-flex align-items-start">
        <img :src="`${record.showimg_url}?tr=cm-pad_resize,w-100,h-100,bg-FFFFFF`" class="img-thumbnail mr-3" />

        <router-link :to="{ name: 'catalogue.product.edit', params: { id: record.product_id } }">
          <span>{{ record.title }}</span>
        </router-link>
      </div>

      <template #price="record">
        <div>
          {{ record.min_sellingprice | currency }}
          <span v-if="record.max_sellingprice > record.min_sellingprice">
          - {{ record.max_sellingprice | currency }}
          </span>
        </div>
      </template>

      <template #qty="record">
        <div v-if="$store.state.app.name === 'dompetdhuafa'">
          <div class="text-center">
            <span class="text-success">Available</span>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <span v-if="record.in_stock" class="text-success">Available</span>
            <span v-else class="text-muted">Out of stock</span>
          </div>
          <div class="text-muted small" v-if="record.variant_count > 1">From {{ record.variant_count }} variants</div>
        </div>
      </template>

      <template #published="record">
        <a-switch :default-checked="record.is_valid ? true : false" @change="(checked) => updatePublished(checked, record)"  />
      </template>

      <template #attributes="record">
        <div v-if="record.attributes.length">
          <div class="mt-1" v-for="(item, index) in record.attributes" :key="index">
            <div class="text-muted" v-if="item.type !== 'text' && item.type !== 'longtext'">{{ item.name }}</div>
            <div v-if="item.type !== 'text' && item.type !== 'longtext'">
              <div v-if="item.type === 'currency'"> {{ Number(item.text) | currency }} </div>
              <div v-else-if="item.type === 'date'"> {{ $moment(Number(item.text) * 1000).format('YYYY-MMMM-DD HH:mm:ss') }} </div>
            </div>
          </div>
        </div>
        <div v-else>
          -
        </div>
      </template>

      <template #action="record">
        <router-link :to="{ name: 'catalogue.product.edit', params: { id: record.product_id } }">
          <a-button type="link">
            Edit
          </a-button>
        </router-link>
      </template>
    </a-table>
    <div class="py-3" v-if="totalRows">
      <a-pagination
      :default-current="page"
      :total="totalRows"
      :default-page-size="perPageNumber"
      @change="(val) => $router.push({
        name: 'catalogue.product.index',
        query: { ...$route.query, page: val}
      })" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'

const columns = [
  {
    title: 'Name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
    width: 300,
  },
  {
    title: 'Price',
    key: 'price',
    scopedSlots: { customRender: 'price' },
    width: 75,
    class: 'text-right',
  },
  {
    title: 'Quantity',
    key: 'qty',
    scopedSlots: { customRender: 'qty' },
    width: 50,
    class: 'text-center',
  },
  {
    title: 'Published',
    key: 'published',
    scopedSlots: { customRender: 'published' },
    width: 50,
    class: 'text-center',
  },
  {
    title: 'Attributes',
    key: 'attributes',
    scopedSlots: { customRender: 'attributes' },
    width: 100,
    class: 'text-center',
  },
  {
    title: 'Action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: 35,
    class: 'text-center',
  },
]
export default {
  name: 'ProductList',
  data() {
    return {
      filter: {
        q: null,
      },
    }
  },
  mounted() {},
  created() {
    this.onQueryChanged = debounce(($e) => {
      this.$router.push({
        query: {
          ...this.$route.query,
          q: $e.target.value,
          page: 1,
        },
      })
    }, 1000)
  },
  computed: {
    columns () {
      const filterColumns = columns.filter(item => this.$store.state.app.show_attr_list ? item : item.key !== 'attributes')

      // console.log(filterColumns)

      return filterColumns
    },
    ...mapState('catalogue', {
      products: (state) => state.products,
      totalRows: 'totalRows',
      loading: 'isLoadingProduct',
    }),
    page() {
      return Number(this.$route.query.page || 1)
    },
    perPageNumber() {
      return Number(this.$route.query.perPage) || 35
    },
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler: function () {
        this.$nextTick(() => this.fetch())
      },
    },
  },
  methods: {
    fetch() {
      const { page = 1 } = this.$route.query
      const pageNumber = Number(page) < 0 || Number.isNaN(Number(page)) ? 1 : Number(page)

      this.$store.dispatch('catalogue/getProducts', {
        query: this.$route.query.q,
        page: pageNumber,
        limit: this.perPageNumber,
      })
    },
    isPreOrder(item) {
      return item.item_preorder === 'yes'
    },
    debounce(func, time) {
      return debounce(func, time)
    },
    updatePublished (checked, record) {
      this.$store.dispatch('catalogue/updatePublishedProduct', {
        uuid: record.product_id,
        is_valid: checked ? 1 : 0,
      })
        .then(response => {
          this.fetch()
        })
        .catch(err => {
          //
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss">
.table-products {
  tr {
    > th,
    > td {
      padding: 8px !important;
    }

    > th {
      font-weight: bold !important;
    }

    td {
      vertical-align: top;
    }
  }

  .img-thumbnail {
    max-width: 55px;
  }

  .strike {
    text-decoration: line-through;
    color: #999;
    font-size: 90%;
  }
}
</style>
